<template>
  <div>
    <slot :records="recordsToDefaultBlock" />

    <div v-if="recordsToCollapseBlock.length">
      <TCollapse :visible="expanded">
        <slot :records="recordsToCollapseBlock" />
      </TCollapse>

      <TButton
        variant="link"
        class="p-0"
        @click="expanded = !expanded"
      >
        {{ expanded ? t('actions.showLess') : t('actions.showMore') }}
      </TButton>
    </div>
  </div>
</template>

<script setup lang="ts" generic="T">
const props = defineProps<{
  records: T[]
  quantityToShowWhenCollapsed: number
}>()

const { t } = useI18n()

const expanded = ref(false)

const recordsToDefaultBlock = computed(() => {
  return props.records.slice(0, props.quantityToShowWhenCollapsed)
})

const recordsToCollapseBlock = computed(() => {
  return props.records.slice(props.quantityToShowWhenCollapsed)
})
</script>
